import React from 'react';
import { writeEventToDb } from './utils/ApiUtils';
import LoginModal from './LoginModal';
import LoginWeb from './common/LoginWeb';
import LoginMobile from './common/LoginMobile';

let isMobile = false;

export default class AppLogin extends React.Component {
  constructor(props) {
    super(props);
    isMobile = this.props.isMobile;
    this.state = { email1: '', email2: '', modalVisible: false, modalNumber: 1 };
  }
  componentDidMount() {
    let windowUrl = window.location.href;
    if(windowUrl.includes('/signup-invite/')||windowUrl.includes('/reset-password-invite/')) {
      const words = windowUrl.split('/');
      let token = words[words.length-1];
      console.log('emailToken='+token);
      this.setState({ modalNumber: 3, modalVisible: true });
    }
    this.loginPageLoadEvent();
  }
  loginPageLoadEvent = async() => {
    console.log('fetch basic info');
    let basicInfo = this.props.basicInfo;
    let uniqueId = this.props.uniqueId;
    let analyticsObj = { ...basicInfo, eventName: 'loginPageLoaded', timeStamp: Date.now() };
    let updates = { };
    updates[uniqueId] = analyticsObj;
    console.log('basic Info='+JSON.stringify(updates));
    writeEventToDb(updates);
  }
  setModalVisible = (modalVisible) => {
    console.log('modalVisible='+modalVisible);
    window.history.replaceState(null, null, "/");
    this.setState({ modalVisible: modalVisible, modalNumber: 1 });
  }
  setLogin = () => {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    this.setState({ modalVisible: false });
    this.props.goToLanding(1);
  }

  render() { 
    return (
      <div>
        { isMobile
        ?
        <LoginMobile setVisibility={this.setModalVisible} />
        :
        <LoginWeb setVisibility={this.setModalVisible} />
        }
        { this.state.modalVisible && 
          <LoginModal basicInfo={this.props.basicInfo} uniqueId={this.props.uniqueId} 
          modalNumber={this.state.modalNumber} setLogin={this.setLogin} setVisibility={this.setModalVisible} />
        }
      </div>
    );
  }
}
